import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import {
  SFTypography,
  SFButton,
  SFIcons,
  SFProgress,
  SFStack,
  SFLoadingSpinner,
  SFUseStyled
} from "@sf-core";
import { saveCourseTrack } from "../../services/courseService";
import { getNextCourse } from "../../services/domainService";
import { enrollInDomain } from "../../redux/reducers/domainReducer";
import { STATUS } from "../../constants/statuses";
import { CONTENT_TYPE } from "../../constants/contentType";
import { getCourseUrl } from "../../constants/urls";


const { styled } = SFUseStyled();

const PlayButtonStyled = styled(SFButton)(({ theme }) => ({ 
  minWidth :"127px",
}));

export const PlayButton = ({
  itemId,
  status,
  completedDuration,
  totalDuration,
  completedCourses,
  totalCourses,
  totalSkillsPaths,
  completedSkillPaths,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  
  let buttonLabel = null;

  const progressLiteralValue = (type) =>{
    if (status === STATUS.NOT_STARTED) {
      return t("lxpComponents.basicDetails.button.notStarted");
    }

    if (type === CONTENT_TYPE.COURSE) {
      return t("lxpComponents.basicDetails.completedCourses", {
        completed: completedCourses,
        total: totalCourses,
      });
    }else if (type === CONTENT_TYPE.SKILLS_PATH) {
      return t("lxpComponents.basicDetails.completedSkillsPaths", {
        completed: completedSkillPaths,
        total: totalSkillsPaths,
      });
    } 
  };

  if (status === STATUS.NOT_STARTED) {
    buttonLabel = t("lxpComponents.basicDetails.button.startLabel");
  } else if (status === STATUS.IN_PROGRESS) {
    buttonLabel = t("lxpComponents.basicDetails.button.resumeLabel");
  }

  const handleClick = async () => {
    setLoading(true);
    if (status === STATUS.NOT_STARTED) {
      dispatch(enrollInDomain(itemId));
    }
    getNextCourse(itemId)
      .then((res) => {
        // Request to track the skillPath id from where the course was accessed
        let data = {
          skillPathId: res.data.skillPathId,
          contentId: res.data.id,
        };
        saveCourseTrack(data);
        navigate(getCourseUrl(res.data.id), { state: { previousLoc: location.pathname } });
      })
      .finally((res) => setLoading(false));
  };

  return (
    <SFStack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={2.5}
    >
      {buttonLabel && (
        <PlayButtonStyled
          variant="secondary"
          size={"large"}
          onClick={loading ? () => { } : handleClick}
        >
          <SFStack spacing={1} direction="row" alignItems={"center"}>
            {loading ? (
              <SFLoadingSpinner size={"large"} />
            ) : (
              <SFIcons.SFPlayIcon size={"large"} />
            )}
            <SFTypography>{buttonLabel}</SFTypography>
          </SFStack>
        </PlayButtonStyled>
      )}
      <SFProgress
        title={progressLiteralValue(CONTENT_TYPE.COURSE)}
        value={(completedDuration / totalDuration) * 100}
        maxWidth="400px"
      />

      {totalSkillsPaths > 0 && status === STATUS.IN_PROGRESS && (
        <SFProgress
          title={progressLiteralValue(CONTENT_TYPE.SKILLS_PATH)}
          value={(completedSkillPaths / totalSkillsPaths) * 100}
          maxWidth="400px"
        />) 
      }
    </SFStack>
  );
};

export default PlayButton;
